export default __webpack_public_path__ + "static/media/bull-one.5063786c.png";